export const uxDesignerResources = {
  junior: {
    macos: [
      'UX Fundamentals Course',
      'Design Thinking Bootcamp', 
      'Figma Basics Tutorial',
      'User Research 101',
      'macOS Design Tools Guide'
    ],
    windows: [
      'UX Fundamentals Course',
      'Design Thinking Bootcamp',
      'Figma Basics Tutorial', 
      'User Research 101',
      'Windows Design Setup Guide'
    ],
    linux: [
      'UX Fundamentals Course',
      'Design Thinking Bootcamp',
      'Figma Web Tutorial',
      'User Research 101', 
      'Linux Design Workflow Guide'
    ]
  },
  mid: {
    macos: [
      'Advanced UX Methods',
      'Research Operations',
      'Accessibility Guidelines',
      'Design Systems Fundamentals',
      'macOS Productivity Setup'
    ],
    windows: [
      'Advanced UX Methods',
      'Research Operations', 
      'Accessibility Guidelines',
      'Design Systems Fundamentals',
      'Windows Productivity Setup'
    ],
    linux: [
      'Advanced UX Methods',
      'Research Operations',
      'Accessibility Guidelines', 
      'Design Systems Fundamentals',
      'Linux Productivity Setup'
    ]
  },
  senior: {
    macos: [
      'UX Leadership Guide',
      'Strategic Design Thinking',
      'Team Management Resources',
      'Design Org Building',
      'Advanced macOS Workflow'
    ],
    windows: [
      'UX Leadership Guide',
      'Strategic Design Thinking',
      'Team Management Resources',
      'Design Org Building', 
      'Advanced Windows Workflow'
    ],
    linux: [
      'UX Leadership Guide',
      'Strategic Design Thinking',
      'Team Management Resources',
      'Design Org Building',
      'Advanced Linux Workflow'
    ]
  }
};
